class GridSwitcher extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.buttonSelector = 'button[data-grid-switcher-el][data-grid-view]'
    this.activeClass = 'clc-ProductGrid_GridButton-active'

    this.gridClasses = {
      single: 'prd-List_Items-single',
      small: 'prd-List_Items-small',
      medium: 'prd-List_Items-medium',
      large: 'prd-List_Items-large',
    }

    this.productListEl =
      this.externalEls?.productList?.element ||
      this.closest('[data-collection-root]')?.querySelector(
        '.prd-List_Items',
      ) ||
      document.querySelector('.prd-List_Items')

    this.applyInitialFromActiveButton()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'click', evt => {
      const trigger = evt.target.closest(this.buttonSelector)
      if (!trigger || !this.contains(trigger)) return

      // prevent accidental form submit if inside a form
      if (trigger.tagName === 'BUTTON' && !trigger.getAttribute('type')) {
        trigger.setAttribute('type', 'button')
      }

      evt.preventDefault()
      this.handleGridSwitch(trigger)
    })
  }

  applyInitialFromActiveButton () {
    const activeBtn = this.querySelector(
      `${this.buttonSelector}.${this.activeClass}`,
    )
    const fallbackBtn = this.querySelector(this.buttonSelector)
    const btn = activeBtn || fallbackBtn
    if (!btn) return

    const layout = btn.dataset.gridView
    if (!layout) return

    this.updateGridClass(layout)
  }

  async handleGridSwitch (btn) {
    const layout = btn?.dataset?.gridView
    if (!layout) return

    this.toggleActiveButton(btn)
    this.updateGridClass(layout)

    try {
      await window.BAO.Cart.updateCartAttributes({ 'grid-layout': layout })
    } catch (e) {
      console.warn('Failed to update cart attributes:', e)
    }
  }

  toggleActiveButton (activeBtn) {
    const buttons = this.querySelectorAll(this.buttonSelector)
    buttons.forEach(b => b.classList.toggle(this.activeClass, b === activeBtn))
  }

  updateGridClass (layout) {
    if (!this.productListEl) return

    Object.values(this.gridClasses).forEach(cls =>
      this.productListEl.classList.remove(cls),
    )
    const cls = this.gridClasses[layout]
    if (cls) this.productListEl.classList.add(cls)
  }
}

if (!customElements.get('grid-switcher')) {
  customElements.define('grid-switcher', GridSwitcher)
}
